import wopr1 from '../assets/projects/wopr1.webp';
import wopr2 from '../assets/projects/wopr2.webp';
import idleveil1 from '../assets/projects/idleveil1.webp';
import mandatum3 from '../assets/projects/mandatum3.webp';
import mandatum4 from '../assets/projects/mandatum4.webp';

export const products = [
  {
    id: 'mandatum',
    name: 'Mandatum',
    tagline: 'Prompt engineering platform with custom code execution',
    description: 'A prompt engineering SaaS platform that combines prompt management with custom code execution. Currently live and in alpha, fully functional for testing. Manage, test, and deploy AI prompts without code deployments while writing custom pre and post-processors that run alongside your LLM calls. Features visual prompt editing, version control, multi-provider support (OpenAI, Anthropic, Google), A/B testing, and comprehensive analytics.',
    image: mandatum3,
    listImage: mandatum4,
    gallery: [mandatum3, mandatum4],
    features: [
      'Visual prompt editor with version control',
      'Custom pre and post-processor code execution',
      'Multi-provider support (OpenAI, Anthropic, Google)',
      'A/B testing for prompts and models',
      'Request logging and cost tracking',
      'Team collaboration with role-based access',
      'Sandboxed Python execution environment',
      'Performance analytics and metrics'
    ],
    requirements: [
      'Modern web browser',
      'Mandatum API key'
    ],
    siteUrl: 'https://mandatum.netlify.app/',
    releaseDate: '2025',
    status: 'alpha'
  },
  {
    id: 'idleveil',
    name: 'Idleveil',
    tagline: 'Hardcore text RPG with permadeath',
    description: 'A strategic text-based RPG where every decision matters. Currently live and in alpha, fully functional for testing. Built with Angular 20 and .NET 8, featuring hardcore permadeath mechanics, turn-based PvE and PvP combat, character progression, guilds, raids, and dungeons. Log in with Google and forge your legend in the arena.',
    image: idleveil1,
    features: [
      'Hardcore permadeath mechanics',
      'Turn-based PvE & PvP auto-combat',
      'Character progression and loot system',
      'Guilds, raids, and dungeons',
      'Google OAuth authentication',
      'Persistent account progress across deaths',
      'Real-time chat and social features',
      'Daily missions and achievements'
    ],
    requirements: [
      'Modern web browser',
      'Google account for sign-in'
    ],
    playUrl: 'https://idleveil.netlify.app',
    releaseDate: '2026',
    status: 'alpha'
  },
  {
    id: 'wopr',
    name: 'WOPR',
    tagline: 'Retro-styled AI desktop assistant',
    description: 'A retro-styled AI desktop assistant built with Tauri and SvelteKit, designed to live on a secondary display. Features multi-provider AI chat with vision support (OpenAI, Anthropic, Gemini), voice activation with wake word detection, real-time system monitoring, and activity tracking. Includes a persistent memory system, web search capabilities, and two UI themes: a WarGames-inspired retro terminal and a cozy modern design.',
    image: wopr1,
    listImage: wopr2,
    gallery: [wopr1, wopr2],
    features: [
      'Multi-provider AI chat (OpenAI, Anthropic, Gemini)',
      'Vision support for image analysis',
      'Voice activation with wake word detection',
      'Real-time system monitoring',
      'Persistent memory system',
      'Web search capabilities',
      'Two UI themes: Retro terminal & Modern',
      'Activity tracking'
    ],
    requirements: [
      'macOS 12.0+ or Windows 10+',
      '50 MB disk space'
    ],
    downloads: {
      mac: {
        label: 'Download for Mac',
        url: 'https://downloads.gavelinivar.com/WOPR_0.1.0_aarch64.dmg',
        available: true
      },
      windows: {
        label: 'Download for Windows',
        url: 'https://downloads.gavelinivar.com/WOPR_0.1.0_x64-setup.exe',
        available: true
      }
    },
    releaseDate: '2025',
    status: 'released'
  }
];

export const getProductById = (id) => products.find(p => p.id === id);
export const getReleasedProducts = () => products.filter(p => p.status === 'released');
